const getFontFamilyFallbacks = (preferredFontFamily: string) => {
  return `${preferredFontFamily}, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`
}

export const FONT_FAMILIES = {
  primary: getFontFamilyFallbacks(`Inter`),
} as const
